import React from 'react';
import Login from '../Components/Login/Login';

function LoginPage() {
  return (
    <div>
      <Login />
    </div>
  );
}

export default LoginPage;
